import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="bg-white px-4 py-6 sm:px-6" aria-labelledby="testimonials-heading" data-id="element-154" data-mp="3kqw54mwtl6h6">
      <div className="mb-3 text-center" data-id="element-155" data-mp="3fycoti6qzx8o">
        <h2 id="testimonials-heading" className="mb-1 text-2xl leading-none text-brand-ink sm:text-4xl" data-id="element-156" data-mp="3fxb6csnek8gx">
          WHAT COACHES ARE SAYING
        </h2>
        <p className="font-heading text-[11px] font-semibold uppercase tracking-wide text-brand-red sm:text-xs" data-id="element-157" data-mp="36wwf7cnrbz5i">
          Verified reviews from professional boxing coaches
        </p>
      </div>
      <div className="space-y-2" data-id="element-158" data-mp="2x11pjxl493t8">
        {testimonials.map(testimonial => <article key={testimonial.author} className="rounded-xl border border-black/5 bg-brand-light p-3 shadow-sm" data-id="element-159" data-mp="2s39puhe8cdeh">
            <div className="mb-1 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-160" data-mp="qalko2i0zfw2">
              {Array.from({
            length: 5
          }, (_, index) => <StarIcon key={index} className="h-3 w-3 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-161" data-mp="h55ba4bmvzy5" />)}
            </div>
            <p className="mb-2 text-[11px] italic leading-snug text-brand-ink/80 sm:text-xs" data-id="element-162" data-mp="79lelfp8wx8c">
              “{testimonial.text}”
            </p>
            <div className="flex items-center gap-2 border-t border-black/5 pt-2" data-id="element-163" data-mp="zwpqm4mrabtm">
              <span className="flex h-7 w-7 items-center justify-center rounded-full bg-brand-red font-heading text-xs font-semibold text-white" data-id="element-164" data-mp="14vj2xtqb3ws7">
                {testimonial.author.charAt(0)}
              </span>
              <div data-id="element-165" data-mp="v5g257cy1ejb">
                <p className="font-heading text-[11px] font-semibold text-brand-ink" data-id="element-166" data-mp="v4xz9rvs022f">
                  — {testimonial.author}
                </p>
                <p className="text-[9px] font-medium uppercase tracking-wide text-brand-muted" data-id="element-167" data-mp="1it7do8qntnjj">
                  {testimonial.role} — {testimonial.location}
                </p>
              </div>
            </div>
          </article>)}
      </div>
    </section>;
}